import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: null,
    isFetching: false,
    error: false,
    locked: false,
  },
  reducers: {
    loginStart: (state) => {
      state.isFetching = true;
    },
    loginSuccess: (state, action) => {
      state.isFetching = false;
      state.currentUser = action.payload;
      state.error = false;
      state.locked = false;
    },
    loginFailure: (state) => {
      state.isFetching = false;
      state.error = true;
      state.locked = false;
    },
    loginLocked: (state) => {
      state.isFetching = false;
      state.error = false;
      state.locked = true;
    },
    sessionSuccess:(state,action) =>{
      state.currentUser = {...state.currentUser, exp: action.payload.exp, accessToken: action.payload.newToken, lastActivity: action.payload.lastActivity}
    },
    logoutStart: (state) => {
      state.currentUser = null;
      state.isFetching = false;
      state.error = false;
      state.locked = false;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, loginLocked, sessionSuccess, logoutStart } =
  loginSlice.actions;
export default loginSlice.reducer;
